'use strict';

var currencies = require('./currencies');
var constants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$'
    },
    abbreviations: {
        CAD: 'CAD',
        AUD: 'AUD',
        MXN: 'MXN',
        CHF: 'CHF'
    }
};

currencies.forEach(function (currency) {
    constants.currencies['CURRENCY_' + currency] = currency;
});

module.exports = constants;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-currency-helpers/constants.js
// module id = 275
// module chunks = 62